import { useEffect, useState } from 'react';

/**
 * Hook to detect if the client is on a mobile device.
 * @param mobileBreakpoint - The maximum width in pixels to consider as mobile (default: 768)
 * @returns Boolean indicating if the device is mobile
 */
export function useMobileDetection(mobileBreakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Initial check
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileUserAgents = [
        'android',
        'webos',
        'iphone',
        'ipad',
        'ipod',
        'blackberry',
        'windows phone',
      ];
      const isMobileByUserAgent = mobileUserAgents.some((ua) =>
        userAgent.includes(ua)
      );

      // Check screen width as well
      const isMobileByWidth = window.innerWidth <= mobileBreakpoint;

      setIsMobile(isMobileByUserAgent || isMobileByWidth);
    };

    // Run the check immediately
    checkIfMobile();

    // Re-check when window is resized
    window.addEventListener('resize', checkIfMobile);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [mobileBreakpoint]);

  return isMobile;
}
